<template>
  <div class="question-add">
    <p class="title">{{ titleMsg }}</p>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="groupForm"
      ref="groupForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="班组名称：" prop="groupName">
            <el-input
              v-model="groupForm.groupName"
              placeholder="请输入班组名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班组组长：" prop="leaderUserName">
            <el-input
              readonly
              v-model="groupForm.leaderUserName"
              placeholder="请从下方列表中选择一个成员作为组长"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 28px">
        <el-col :span="10" class="right-wrap" style="float: right">
          <div class="btn-div">
            <el-checkbox
              :disabled="dragDisabled"
              v-model="dragaable"
              class="drag-box mr16"
              >拖拽排序</el-checkbox
            >
            <el-button
              class="mr16"
              :disabled="userIds.length == 0"
              size="small"
              @click="deleteGroupUsers"
              >批量移除</el-button
            >
            <el-button type="primary" size="small" @click="groupUserManage"
              >组员管理</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="组员列表：">
            <Table
              :class="{ 'list-drag': dragaable }"
              :data="groupForm.groupUserList"
              @selection-change="selectChange"
              row-key="enrollId"
            ></Table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="dialog-footer" label-width="0">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="$router.back()">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <UserManage />
  </div>
</template>

<script>
import Table from "@/views/onlineClass/editClassGroup/table.js";
import Sortable from "sortablejs";
import { getGroupInfo, saveGroup, updateGroup } from "@/api/enrollment";
import vue from "@/main";
import { Confirm } from "@/components/Confirm";
import UserManage from "@/views/onlineClass/editClassGroup/userManage.vue";
export default {
  components: { Table, UserManage },
  data() {
    return {
      dragaable: false, //控制拖拽排序,
      titleMsg: "添加分组",
      classId: "",
      editId: null,
      groupForm: {
        groupName: "",
        leaderUserName: "",
        groupUserList: [],
      },
      checkArray: [],
      pathOptions: {},
      rules: {
        groupName: [
          {
            required: true,
            message: "请输入班组名称",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        leaderUserName: [
          {
            required: true,
            message: "请选择班组组长",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    userIds() {
      return this.checkArray.map((item) => item.uuid);
    },
    dragDisabled() {
      if (this.groupForm.groupUserList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.indexOf("/offline/groupList") != -1) {
        vm.pathOptions = {
          path: from.path,
          query: from.query
        }
      }
    });
  },
  created() {
    this.classId = this.$route.query.classId;
    this.editId = this.$route.query.id;
    if (this.editId) {
      this.titleMsg = "编辑分组";
      this.getGroupInfo();
    }
    vue.$on("removeGroupUser", (item) => {
      this.removeGroupUser(item);
    });
    vue.$on("setLeaderUser", (item) => {
      this.setLeaderUser(item);
    });
    vue.$on("addGroupUsers", (groupUserList) => {
      this.addGroupUsers(groupUserList);
    });
  },
  methods: {
    // 分组详情
    getGroupInfo() {
      getGroupInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        this.groupForm = res.data;
      });
    },
    addGroupUsers(groupUserList) {
      this.groupForm.groupUserList = groupUserList;
    },
    // 移除组员
    async removeGroupUser(item) {
      try {
        await Confirm(`确认移除该学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        let groupUserList = this.groupForm.groupUserList;
        groupUserList.splice(groupUserList.indexOf(item), 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 设置组长
    setLeaderUser(item) {
      this.groupForm.leaderUserName = item.userName;
      this.groupForm.leaderUserId = item.enrollId;
    },
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",

          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.groupForm.groupUserList.splice(
              oldIndex,
              1
            )[0];
            _this.groupForm.groupUserList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    // 班委管理
    groupUserManage() {
      vue.$emit(
        "groupUserManage",
        this.$route.query.id,
        this.groupForm.groupUserList
      );
    },
    resetForm() {
      this.$refs["groupForm"].resetFields();
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 批量删除
    deleteGroupUsers() {
      this.$confirm(`确认批量移除选中的学员吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.checkArray.length; i++) {
            let groupUserList = this.groupForm.groupUserList;
            groupUserList.splice(this.checkArray[i], 1);
          }
        })
        .catch(() => {});
    },
    //更新分组
    submit() {
      this.$refs["groupForm"].validate().then(() => {
        if (this.groupForm.groupUserList && this.groupForm.groupUserList) {
          this.groupForm.enrollIdList = this.groupForm.groupUserList.map(
            (item) => item.enrollId
          );
        } else {
          this.groupForm.enrollIdList = [];
        }
        let params = Object.assign({}, this.groupForm);
        params.classId = this.classId;
        if (this.editId) {
          updateGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "分组修改成功！",
              type: "success",
            });
            this.$router.back();
          });
        } else {
          saveGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.$router.back();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-add {
  $textColor: #51627d;
  $textSize: 12px;
  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }
  /deep/ .el-dialog__body {
    padding: 30px 30px 30px 20px;
  }
  .form {
    padding: 10px 20px;
  }
  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }
  .delete-choose {
    position: absolute;
    top: 10px;
    right: -19px;
    font-size: 14px;
    cursor: pointer;
  }
  .form-select {
    width: 100%;
    &.has-btn {
      width: calc(100% - 120px);
    }
  }
  .mr16 {
    margin-right: 16px;
  }
}
.btn-div {
  float: right;
  /deep/ .drag-box {
    .el-checkbox__label {
      font-size: 12px;
      color: #51627d;
      font-weight: normal;
    }
  }
}
.dialog-footer {
  text-align: center;
}
.right-wrap {
  float: right;
  margin-bottom: 18px;
}
</style>
